import { render, staticRenderFns } from "./NotificationFeed.vue?vue&type=template&id=6323036e&scoped=true"
import script from "./NotificationFeed.vue?vue&type=script&lang=js"
export * from "./NotificationFeed.vue?vue&type=script&lang=js"
import style0 from "./NotificationFeed.vue?vue&type=style&index=0&id=6323036e&prod&lang=css"
import style1 from "./NotificationFeed.vue?vue&type=style&index=1&id=6323036e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6323036e",
  null
  
)

export default component.exports